import compose from 'recompose/compose';
import { connect } from 'react-redux';
import VehiclePlatformsSituation from './VehiclePlatformsSituation';

export default compose(
  connect(
    (state) => ({
      platformsSituation: state.vehicles.vehicleDetails.data?.platformsSituation
    })
  )
)(VehiclePlatformsSituation);